<form [formGroup]="form" (ngSubmit)="submit()">
	<app-form-title [editMode]="course() !== undefined" model="Course"></app-form-title>

	<app-name-field [fg]="form" formGroupOrControlName="name"></app-name-field>

	<app-html-description-field
		[fg]="form"
		formGroupOrControlName="descriptionHtml"
		label="Description"
	></app-html-description-field>

	<app-text-field [fg]="form" formGroupOrControlName="descriptionShort" label="Short Description"></app-text-field>

	@if (hasLocations() && course()) {
		<app-section-editor [course]="course()"></app-section-editor>
		<br />
	}

	@if (!course()) {
		<nz-alert nzType="warning" nzMessage="Save the course first then you can add sections to it."></nz-alert>
		<br />
	}

	@if (!hasLocations()) {
		<nz-alert
			nzType="error"
			nzMessage="You cannot add sections unless you have first created a location."
		></nz-alert>
		<br />
	}

	<app-product-dropdown-field
		[fg]="form"
		formGroupOrControlName="productName"
		label="Product"
		(onChange)="productChanged($event)"
	></app-product-dropdown-field>

	<!-- only show this if it is a stride engine-->
	@if (engineName() === Engines.STRIDE) {
		<app-rubric-dropdown-field
			[fg]="form"
			formGroupOrControlName="rubricCode"
			label="Rubric"
		></app-rubric-dropdown-field>
	}

	<app-text-field [fg]="form" formGroupOrControlName="ssoCourseId" label="SSO Course ID"></app-text-field>

	<app-textarea-field [fg]="form" formGroupOrControlName="dataJson" label="Data JSON"></app-textarea-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
		<button nz-button type="button" (click)="clear()">Clear</button>
	</div>
</form>
